export const CONTAINER_MODEL = {
  aditionalClass: "section-main section-main__internal"
};

export const DETAILS_MODEL = {
  client: true,
  modal: {
    open: {
      icon: "",
      title: "Ingresa tu correo electrónico",
      subtitle: "Recibirás la constancia de tu SOAT para el auto con placa [placa]."
    },
    success: {
      icon: "RideFiSendInfoLight",
      title: "¡Hemos enviado la información!",
      subtitle: "Revisa tu bandeja de correo electrónico, allí encontrarás la constancia de tu SOAT."
    },
    errorEmail: {
      icon: "RideFiErrorLight",
      title: "¡Oops! Algo salió mal",
      subtitle: "No hemos podido enviar la información a tu correo, pero recuerda que puedes obtener tu SOAT electrónico dándole click al botón “Descargar”."
    },
    errorDownload: {
      icon: "RideFiErrorLight",
      title: "¡Oops! Algo salió mal",
      subtitle: "No hemos podido realizar la descarga de tu SOAT electrónico. Por favor, inténtalo de nuevo más tarde."
    }
  },
  titleModalOpen: "<h4>Ingresa tu correo electrónico</h4><p>Recibirás la constancia de tu SOAT para el auto con placa [placa].</p>",
  titleModalSuccess: "<img src='/consulta-soat/assets/persona-exito-modal.svg' alt='Rimac Seguros' width={96} height={132}/><h4>¡Hemos enviado la información!</h4><p>Revisa tu bandeja de correo electrónico, allí encontrarás la constancia de tu SOAT.</p>",
  titleModalErrEmail: "<img src='/consulta-soat/assets/persona-modal-error.svg' alt='Rimac Seguros' width={96} height={132} /><h4>¡Oops! Algo salió mal</h4><p>No hemos podido enviar la información a tu correo, pero recuerda que puedes obtener tu SOAT electrónico dándole click al botón “Descargar”.</p>",
  titleModalErrDownload: "<img src='/consulta-soat/assets/persona-modal-error.svg' alt='Rimac Seguros' width={96} height={132} /><h4>¡Oops! Algo salió mal</h4><p>No hemos podido realizar la descarga de tu SOAT electrónico. Por favor, inténtalo de nuevo más tarde.</p>",
  prevStep: "",
  textBack: "Volver",
  titleClass: "internal-title internal-title-client",
  mainTitles: [
    {
      key: "VIGENTE",
      title: "<h1>Todo en orden </br>con tu SOAT</h1><p>No esperes a que se venza, cómpralo desde hoy y <b>100% online</b></p>"
    },
    {
      key: "POR_VENCER",
      title: "<h1>Es momento de </br>renovar tu SOAT</h1><p>Hazlo ahora y paga <b>desde S/39 al año</b></p>"
    },
    {
      key: "VENCIDO",
      title: "<h1>¡Tu SOAT está vencido,</br>evita las multas!</h1><p>Obténlo <b>desde S/39 al año</b>.</p>"
    },
    {
      key: "FUTURO",
      title: "<h1>Mantén tu SOAT al día</h1><p>Compra online y recibe protección al instante</p>"
    }
  ]
};

export const CARD_DETAILS = {
  imagenCard: "/consulta-soat/assets/icons/icon_soat.svg",
  mainTitlesCard: [
    {
        key: "VIGENTE",
        title: "Llévalo desde S/39 al año",
        beforeText: "Adelanta tu compra"
    },
    {
        key: "POR_VENCER",
        title: "Renueva tu SOAT hoy",
        beforeText: "Conduce seguro"
    },
    {
        key: "VENCIDO",
        title: "Compra tu SOAT hoy",
        beforeText: "Cuida tu seguridad"
    },
    {
      key: "FUTURO",
      title: "Compra tu SOAT hoy",
      beforeText: "Cuida tu seguridad"
  }
  ],
  listtBenefits: [
    {
        imagen: "RideGlPremiumHealthSolid",
        description: "Planes de acuerdo a tus necesidades"
    },
    {
        imagen: "RideGlWheelchairSolid",
        description: "Cubrimos gastos medicos, incapacidad, invalidez permanente y más"
    },
    {
        imagen: "RideGlHospitalSolid",
        description: "Recibe atención inmediata en caso de accidentes"
    }
  ],
  oneStep: true,
  client: true,
  marking: "Ir a comprar",
  mainLinks: [
    {
        key: "VIGENTE",
        link: "[URL]/comprar/soat-digital?pcid=publica:consulta-soat:clientes:resultado:poliza-vigente",
        title: "Ir a comprar"
    },
    {
        key: "POR_VENCER",
        link: "[URL]/comprar/soat-digital?pcid=publica:consulta-soat:clientes:resultado:poliza-por-vencer",
        title: "Ir a renovar"
    },
    {
        key: "VENCIDO",
        link: "[URL]/comprar/soat-digital?pcid=publica:consulta-soat:clientes:resultado:poliza-vencida",
        title: "Ir a comprar"
    },
    {
        key: "FUTURO",
        link: "[URL]/comprar/soat-digital?pcid=publica:consulta-soat:clientes:resultado:poliza-futura",
        title: "Ir a comprar"
    }
  ]
};

export const FOOTER_MODEL = {
  altFooter: "Logo Footer",
  address: "Calle Las Begonias 650 Piso 10, San Isidro.",
  txtFooter: "© [year] RIMAC Seguros y Reaseguros."
};